import { Gateway } from '../../types';

export const initialState: Gateway = {
  submitting: false,
  error: null
}